const tutorial = () => {
    return "# Tutorial" +
        "<br>MarkTex is a markdown editor that supports LaTeX and interactive dropdowns." +
        "<br>## Markdown" +
        "<br>See [Markdown Guide](https://www.markdownguide.org/basic-syntax/) for more information." +
        "<br>## LaTeX" +
        "<br>MarkTex supports inline LaTeX and block LaTeX." +
        "<br>### Inline LaTeX" +
        "<br>Inline LaTeX is written between two dollar signs, like this: $x^2$." +
        "<br>### Block LaTeX" +
        "<br>Block LaTeX is opened like this:" +
        "<br>\\[f(x) = x^2\\]" +
        "<br>\\[\\text{det}\\left(\\begin{bmatrix} \\alpha & \\beta \\\\ \\beta & \\gamma \\end{bmatrix}\\right) = 0\\]" +
        "<br>## Other features" +
        "<br>Dropdowns can be written like this:" +
        "<br>::: dropdown | Click this !" +
        "<br>You can include math inside the dropdown as well:" +
        "<br>\\[\\dfrac{-b \\pm \\sqrt{b^2 -- 4ac}}{2a}\\]" +
        "<br>:::" +
        "<br> Emphasize text like this:" +
        "<br>::: theorem | Title" +
        "<br>Content" +
        "<br>::: dropdown | Another dropdown!" +
        "<br> You can put a dropdown inside the box as well. " +
        "<br>:::" +
        "<br>:::" +
        "<br> Emphasize a main point like this: " +
        "<br>::: mainpoint | Title | red" +
        "<br>Content" +
        "<br>:::" +
        "<br> You may color mainpoints with \"red\", \"blue\", \"purple\", \"green\", or \"orange\"." +
        "<br> You can also write code blocks like this: " +
        "<br>```python" +
        "<br>def hello():" +
        "<br>    print('Hello, World!')" +
        "<br>```";
}

export default tutorial;